// initial state
const state = {
  list: []
}

// getters
const getters = {
  breadcrumb: state => state.list
}

// actions
const actions = {

}

// mutations
const mutations = {
  initBreadcrumb (state) {
    state.list = []
  },

  addBreadcrumb (state, payload) {
    let idx = state.list.map(function (e) { return e.name }).indexOf(payload.name)

    idx > -1 ? state.list.splice(idx + 1, state.list.length - idx) : state.list.push(payload)
  },

  removeBreadcrumb (state, payload) {
    console.log('do nothing')
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/breadcrumb.js